<header class="">
  <nav class="navbar navbar-expand-lg navbar-dark">
    <div class="container-fluid">
      <a class="navbar-brand" href="#"><img style="float: left; margin: 4px 10px 0 0;" src="assets/images/home-icon.svg"
          alt="" /> BI Reports</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      
      <div class="collapse navbar-collapse" id="navbarNav">
        <div class="hSearchBox">
          <div class="autocomplete-wrapper" (click)="$event.stopPropagation()">
            <!-- {{searchKeyword | json}} -->
            <!-- <p-autocomplete [(ngModel)]="searchKeyword" [suggestions]="[]" (completeMethod)="search($event)"
              field="reportName" placeholder="Enter your report name" (onSelect)="onSelectItem($event)"> -->
            <!--  <p-autocomplete  [(ngModel)]="searchKeyword"  [suggestions]="[]"   (completeMethod)="search($event)"
    field="reportName"  placeholder="Enter your report name"   (onSelect)="onSelectItem($event)"  (onShow)="dropdownVisible = true"
    (onHide)="dropdownVisible = false" > -->
            <p-autocomplete [(ngModel)]="searchKeyword" [suggestions]="[]" (completeMethod)="search($event)"
              field="reportName" placeholder="Type a report name to search" (onSelect)="onSelectItem($event)">
              <!-- <ng-template let-item pTemplate="item">
                <div class="autocomplete-item" (click)="selectItem($event,item)" >
                    <div class="autocomplete-item">
                      <div class="item-text">
                        <div class="itemTitle">{{ item.reportName }}</div>
                        <span class="item-subText">{{ item.reportDesc }}</span>
                      </div>
                    </div>
                </div>
              </ng-template> -->
            </p-autocomplete>
            <i *ngIf="!searchKeyword" class="pi pi-search"></i>
            <span *ngIf="searchKeyword" class="cursor-pointer sClear" (click)="searchKeywordClear()">Clear</span>
          </div>

          <!-- Display All Modules and Reports -->
          <div *ngIf="showSearchResults && reportsData.modules && reportsData.modules.length > 0 && searchKeyword && searchKeyword.trim()"
            class="grouped-search-results" (click)="$event.stopPropagation()">
            <div class="search-results-header">
              <span>Total {{ getTotalReportsCount() }} reports in {{ reportsData.modules.length }} modules</span>
            </div>
            <div class="search-results-container">
              <div *ngFor="let module of reportsData.modules" class="module-group">
                <div class="module-header">
                  <span class="module-name">{{ module.reportName }}</span>
                  <span class="module-count">({{ module.savedReports && module.savedReports.length > 0 ?
                    module.savedReports.length : 0 }} reports)</span>
                </div>
                <div *ngFor="let report of module.savedReports" class="report-item flex"
                  (click)="selectItem($event, report, module)">
                  <!-- <div class="item-image"><img src="assets/images/search-graph.svg" alt="Image" /></div> -->
                  <div class="item-text">
                    <div class="report-name">{{ report.reportName }}</div>
                    <div class="report-desc">{{ report.reportDesc }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ml-auto cursor-pointer">
          <a *ngIf="!isOnReportDetailsRoute()" (click)="startTakeTour()" style="color: white;">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M12.25 6.41667V2.91667C12.25 2.60725 12.1271 2.3105 11.9083 2.09171C11.6895 1.87292 11.3928 1.75 11.0833 1.75H2.91667C2.60725 1.75 2.3105 1.87292 2.09171 2.09171C1.87292 2.3105 1.75 2.60725 1.75 2.91667V11.0833C1.75 11.3928 1.87292 11.6895 2.09171 11.9083C2.3105 12.1271 2.60725 12.25 2.91667 12.25H6.41667M7.01983 7.39725C6.9988 7.34449 6.9937 7.28673 7.00515 7.2311C7.01661 7.17548 7.04411 7.12443 7.08427 7.08427C7.12443 7.04411 7.17548 7.01661 7.2311 7.00515C7.28673 6.9937 7.34449 6.9988 7.39725 7.01983L12.6472 9.0615C12.7035 9.08349 12.7516 9.12243 12.7848 9.17292C12.818 9.22341 12.8347 9.28297 12.8326 9.34336C12.8305 9.40376 12.8097 9.462 12.773 9.51005C12.7364 9.5581 12.6857 9.59358 12.628 9.61158L10.619 10.2346C10.5284 10.2626 10.4459 10.3123 10.3788 10.3794C10.3117 10.4465 10.262 10.5289 10.234 10.6196L9.61158 12.628C9.59358 12.6857 9.5581 12.7364 9.51005 12.773C9.462 12.8097 9.40376 12.8305 9.34336 12.8326C9.28297 12.8347 9.22341 12.818 9.17292 12.7848C9.12243 12.7516 9.08349 12.7035 9.0615 12.6472L7.01983 7.39725Z" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Take A Tour
          </a>
          <a (click)="showDownloads()" class="ml-5" style="color: white;">
            <i class="pi pi-download"></i>
            Downloads
            <span *ngIf="hasActiveDownloads" class="header-download-badge">
              {{ jobsSummary.pending + jobsSummary.processing }}
            </span>
          </a>
        </div>

        <bi-export-toast
          [visible]="showExportToast"
          [sessionId]="exportToastSessionId"
          [progress]="exportToastOverallProgress"
          [activeCount]="exportToastActiveCount"
          [processedRecords]="exportToastProcessedRecords"
          [totalRecords]="exportToastTotalRecords"
          [completedCount]="exportToastCompletedCount"
          [isReady]="exportToastReady || exportToastAwaitingDismiss"
          [downloadUrl]="latestCompletedDownloadUrl"
          (dismissed)="onExportToastDismissed()"
          (openDownloads)="showDownloads()">
        </bi-export-toast>

        <p-dialog header="Downloads" [(visible)]="showJobsDialog" [modal]="true" [style]="{width: '900px'}" [draggable]="false" [resizable]="false" (onHide)="onDialogHide()">

          <!-- Summary block -->
          <div *ngIf="!jobsLoading" class="jobs-summary">
            <div class="jobs-summary-item summary-pending"
                 [class.active]="selectedStatusFilter === 'pending'"
                 (click)="filterByStatus('pending')">
              <span class="summary-count">{{ jobsSummary.pending }}</span>
              <span class="summary-label">Pending</span>
            </div>
            <div class="jobs-summary-item summary-processing"
                 [class.active]="selectedStatusFilter === 'processing'"
                 (click)="filterByStatus('processing')">
              <span class="summary-count">{{ jobsSummary.processing }}</span>
              <span class="summary-label">Processing</span>
            </div>
            <div class="jobs-summary-item summary-completed"
                 [class.active]="selectedStatusFilter === 'completed'"
                 (click)="filterByStatus('completed')">
              <span class="summary-count">{{ jobsSummary.completed }}</span>
              <span class="summary-label">Completed</span>
            </div>
            <div class="jobs-summary-item summary-failed"
                 [class.active]="selectedStatusFilter === 'failed'"
                 (click)="filterByStatus('failed')">
              <span class="summary-count">{{ jobsSummary.failed }}</span>
              <span class="summary-label">Failed</span>
            </div>
            <div class="jobs-summary-item summary-cancelled"
                 [class.active]="selectedStatusFilter === 'cancelled'"
                 (click)="filterByStatus('cancelled')">
              <span class="summary-count">{{ jobsSummary.cancelled }}</span>
              <span class="summary-label">Cancelled</span>
            </div>
          </div>

          <div *ngIf="!jobsLoading" class="jobs-retention-note">
            <i class="pi pi-info-circle"></i>
            <span>Exported files remain available for download for 24 hours from the time the request is initiated. Once this period has elapsed, the download link will expire and the file will no longer be accessible.</span>
          </div>

          <!-- Loading -->
          <div *ngIf="jobsLoading" class="my-jobs-loading">
            <span class="pi pi-spin pi-spinner"></span> Loading...
          </div>

          <!-- Empty -->
          <div *ngIf="!jobsLoading && filteredJobs.length === 0" class="my-jobs-empty">
            {{ selectedStatusFilter ? 'No ' + selectedStatusFilter + ' jobs found.' : 'No jobs found.' }}
          </div>

          <!-- Jobs list -->
          <div *ngIf="!jobsLoading && filteredJobs.length > 0" class="my-jobs-list">
            <div *ngFor="let job of filteredJobs" class="my-jobs-item">

              <div class="job-row-top">
                <span class="job-file-name">{{ job.result?.fileName || job.jobId }}</span>
                <div class="job-row-actions">
                  <span class="job-status-badge" [ngClass]="'badge-' + job.jobStatus">{{ job.jobStatus }}</span>
                  <button *ngIf="job.jobStatus === 'pending' || job.jobStatus === 'processing'"
                          class="job-cancel-btn"
                          [disabled]="cancellingJobId === job.jobId"
                          (click)="openCancelConfirm(job)">
                    <span *ngIf="cancellingJobId === job.jobId" class="pi pi-spin pi-spinner"></span>
                    <span *ngIf="cancellingJobId !== job.jobId" class="pi pi-times"></span>
                    {{ cancellingJobId === job.jobId ? 'Cancelling...' : 'Cancel' }}
                  </button>
                </div>
              </div>

              <!-- Progress bar -->
              <div class="job-progress-track">
                <div class="job-progress-fill"
                     [ngClass]="'fill-' + job.jobStatus"
                     [style.width.%]="job.progress">
                </div>
              </div>
              <div class="job-progress-labels">
                <span class="progress-pct">{{ job.progress }}%</span>
                <span *ngIf="job.jobStatus === 'processing' && jobsProgressRate[job.jobId]" class="progress-rate">
                  {{ jobsProgressRate[job.jobId].rate | number }} rec/s
                  &nbsp;·&nbsp;
                  ETA {{ jobsProgressRate[job.jobId].eta }}
                </span>
              </div>

              <div class="job-row-meta">
                <span class="job-meta-item">
                  <i class="pi pi-calendar"></i> {{ job.createdAt | date:'dd MMM yyyy, hh:mm a' }}
                </span>
                <span class="job-meta-item">
                  <i class="pi pi-database"></i> {{ job.processedRecords | number }} / {{ job.totalRecords | number }} records
                </span>
              </div>

              <!-- Error message -->
              <div *ngIf="job.jobStatus === 'failed'" class="job-error">
                <i class="pi pi-exclamation-triangle"></i> {{ getFailedJobMessage() }}
              </div>

              <!-- Download link (completed + success) -->
              <div *ngIf="job.jobStatus === 'completed' && job.result?.success === 1 && job.result?.reportUrl" class="job-action">
                <a [href]="job.result.reportUrl" target="_blank" class="job-download-link">
                  <i class="pi pi-download"></i> Download {{ job.result.exportType | uppercase }}
                </a>
              </div>

              <!-- Google Sheets / redirect link -->
              <div *ngIf="job.jobStatus === 'completed' && job.result?.success === 0 && job.result?.redirectUrl" class="job-action">
                <a [href]="job.result.redirectUrl" target="_blank" class="job-auth-link">
                  <i class="pi pi-external-link"></i> {{ job.result.message }}
                </a>
              </div>

            </div>
          </div>

        </p-dialog>

        <!-- Cancel job confirmation dialog -->
        <p-dialog header="Cancel Download" [(visible)]="showCancelConfirm" [modal]="true"
                  [style]="{width: '500px'}" [draggable]="false" [resizable]="false"
                  styleClass="p-cancel-background-job" (onHide)="jobToCancel = null">
          <div class="cancel-confirm-body">
            <p class="cancel-confirm-msg">
              <i class="pi pi-exclamation-circle cancel-confirm-icon"></i>   Are you sure you want to cancel this download?
            </p>
            <p class="cancel-confirm-job-name">{{ jobToCancel?.result?.fileName || jobToCancel?.jobId }}</p>
          </div>
          <ng-template pTemplate="footer">
            <button class="cancel-confirm-no" (click)="showCancelConfirm = false">
              No, Keep It
            </button>
            <button class="cancel-confirm-yes" (click)="confirmCancelJob()">
              <i class="pi pi-times"></i> Yes, Cancel Download
            </button>
          </ng-template>
        </p-dialog>

        <!-- <div class="biUser"><span class="pi pi-user"></span></div> -->

      </div>
    </div>
  </nav>
</header>